import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2 } from "lucide-react";

import Button from "../../Button/Button";
import Container from "../../Container/Container";
import { fadeLeft, fadeRight, floating, staggerContainer, viewportOnce } from "../../../Utils/animations";

import "../../../Style/home/leadGeneration.css";

const funnelStages = [
  { id: 1, label: "Prospects Identified", value: "12,400", width: "100%" },
  { id: 2, label: "Qualified Leads", value: "3,860", width: "72%" },
  { id: 3, label: "Sales Ready", value: "1,240", width: "42%" },
  { id: 4, label: "Closed Won", value: "318", width: "20%" },
];

/** Funnel visualization paired with the section's copy and CTA. */
function LeadGeneration() {
  return (
    <section className="section section--gradient section--grid lead-gen">
      <Container className="lead-gen__grid">
        <motion.div
          className="lead-gen__copy"
          variants={fadeLeft()}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <span className="section-eyebrow">
            <span className="section-eyebrow__dot" aria-hidden="true" />
            Lead Generation
          </span>
          <h2 className="section-title mt-4">
            Generate better leads. <span className="text-gradient">Build better growth.</span>
          </h2>
          <p className="section-description mt-4">
            Every stage of the funnel below is built from the same validated data set, so what
            enters at the top is qualified enough to convert at the bottom.
          </p>

          <ul className="lead-gen__points">
            {["Verified contact data at every stage", "Real-time scoring on intent signals", "CRM-ready handoff to your sales team"].map(
              (point) => (
                <li key={point}>
                  <CheckCircle2 size={18} />
                  {point}
                </li>
              )
            )}
          </ul>

          <Button href="/contact" icon={<ArrowRight size={18} />} className="mt-6">
            Start Generating Leads
          </Button>
        </motion.div>

        <motion.div
          className="lead-gen__visual"
          variants={fadeRight(0.15)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <motion.div className="lead-gen__panel" {...floating(8, 6)}>
            <div className="lead-gen__panel-head">CRM Pipeline</div>
            <motion.div
              className="lead-gen__funnel"
              variants={staggerContainer(0.12)}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
            >
              {funnelStages.map((stage) => (
                <div key={stage.id} className="lead-gen__stage">
                  <div className="lead-gen__stage-head">
                    <span>{stage.label}</span>
                    <span className="lead-gen__stage-value">{stage.value}</span>
                  </div>
                  <div className="lead-gen__bar-track">
                    <motion.span
                      className="lead-gen__bar-fill"
                      initial={{ width: 0 }}
                      whileInView={{ width: stage.width }}
                      viewport={viewportOnce}
                      transition={{ duration: 0.9, ease: "easeOut" }}
                    />
                  </div>
                </div>
              ))}
            </motion.div>
          </motion.div>
        </motion.div>
      </Container>
    </section>
  );
}

export default LeadGeneration;
